import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: {
        format: String,
        tag: {
            required: false,
            type: String,
        },
        value: [Number, Date],
    },
})
export class LocalizedDate extends Vue {
    public tag: string;
    public format: string;
    public unit: string;
    public value: number | Date;

    public render(createElement) {
        return createElement(this.tag || 'span', this.$d(this.value, this.format));
    }
}
